import { ControlType } from "../../../base/types";
import { IControlAttributes } from "../../../base/models";
import { useRef } from "react";
import { MUIIcon } from "../../../widgets";
import { Link } from 'react-router-dom';
import { Button } from "react-bootstrap";
import { Registry } from "../../../base/register";
import { useGetAssessment } from "./properties/useGetAssessment";
import { AssessmentProperties } from "./properties";
import moment from "moment";
import { Spinner } from "react-bootstrap";
import { useGetCoursesName } from "./properties/useGetCoursesName";

export const TakeHomeExaminationComponent = (props: IControlAttributes) => {
  const headingRef = useRef<HTMLDivElement>(null);
  const { assessments, loading } = useGetAssessment();
  const { getCourseName } = useGetCoursesName();
  const currentTime = moment();

  return (
    <>
      <div className="d-flex flex-column flex-md-row" style={{ height: '66vh', overflow: "hidden" }}>
        <div className="d-none d-md-block" style={{ flex: 1, overflow: 'hidden' }}>
          <img
            src={'/media/background-images/exam-gif.gif'}
            alt="Exam Animation"
            className="img-fluid"
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
        <div className="col-md-6 d-flex flex-column justify-content-center">
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" style={{ marginBottom: '10px' }} />
              <div><strong>Loading Exams...</strong></div>
            </div>
          ) : (
            <div className="flex-grow-1" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: "auto", display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '10px', paddingBottom: '50px', marginTop: '8px' }}>
              {assessments.map((item, i) => {
                const startTime = moment(item.starttime);
                const endTime = moment(item.endtime);
                const isButtonEnabled = currentTime.isBetween(startTime, endTime);
                return (
                  <div className="border rounded p-3 bg-light" key={i}>
                    <div className="row">
                      <div className="col-12 col-md-9">
                        <div className="row">
                          <div className="col-12 col-md-6 p-2">
                            <span className="fw-bold">Assessment</span>
                            <div>{item.name}</div>
                          </div>
                          <div className="col-12 col-md-6 p-2">
                            <span className="fw-bold">Course</span>
                            <div>{getCourseName(item.courseId || '')}</div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6 p-2">
                            <span className="fw-bold">Starting on</span>
                            <div>{moment(item.starttime).format('DD-MM-YYYY HH:mm')}</div>
                          </div>
                          <div className="col-12 col-md-6 p-2">
                            <span className="fw-bold">Expiring on</span>
                            <div>{moment(item.endtime).format('DD-MM-YYYY HH:mm')}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 d-flex align-items-center justify-content-end p-1">
                        {isButtonEnabled ? (
                          <Link to={`/exam(${item.assessmentId})`}>
                            <Button
                              style={{ backgroundColor: 'green', borderColor: 'green', color: 'white', marginRight: '10px' }}
                            >
                              <MUIIcon iconName="ExamOutlined" className="me-1" />
                              Take Exam
                            </Button>
                          </Link>
                        ) : (
                          <Button
                            style={{ backgroundColor: 'grey', borderColor: 'grey', color: 'white', marginRight: '10px' }}
                            disabled
                          >
                            <MUIIcon iconName="ExamOutlined" className="me-1" />
                            Take Exam
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

Registry.addControl({
  id: "252c4841-6b7d-47a9-9497-c2a5f6e95270",
  name: "Take Home Examination",
  type: ControlType.TakeHomeExaminationComponent,
  properties: AssessmentProperties,
  component: TakeHomeExaminationComponent
});

